/*
  Geschenkfinder (sections/pk-geschenkfinder.liquid).
  Drei Schritte nacheinander: Für wen → Anlass → Budget; jede Antwort führt zum nächsten Schritt, „Überspringen“
  ebenso. Interessen, Alter und Besonderes stehen als „Weiter eingrenzen“ bei den Ergebnissen.
  Je Gruppe ist ein Wert wählbar; ein erneuter Klick nimmt ihn zurück. Sortiert wird nach der Zahl
  passender Angaben, dann verfügbar, dann aus „Geschenkideen“, dann nach Zahl der Bewertungen.
  Passt nichts zu allen Angaben, stehen die nächstbesten oben – die Seite ist nie leer.
  Die Auswahl steht in der Adresse und lässt sich als Link teilen.
*/
(() => {
  const root = document.querySelector('[data-pk-gf]');
  if (!root) return;

  const SCHRITTE = ['fuer', 'anlass', 'budget'];
  const GRUPPEN = ['fuer', 'anlass', 'interesse', 'budget', 'alter', 'art'];
  const EXTRAS = ['interesse', 'alter', 'art'];
  const KINDER = ['kinder', 'jugendliche'];
  // Preise in Cent; „bis 25 €“ schließt günstigere ein.
  const BUDGET = { 10: [0, 1000], 25: [0, 2500], 50: [0, 5000], ueber50: [5001, Infinity] };

  const panel = root.querySelector('[data-pk-gf-panel]');
  const liste = root.querySelector('[data-pk-gf-liste]');
  const ergebnis = root.querySelector('.pk-gf__ergebnis');
  const status = root.querySelector('[data-pk-gf-status]');
  const hinweis = root.querySelector('[data-pk-gf-hinweis]');
  const aktionen = root.querySelector('[data-pk-gf-aktionen]');
  const eingrenzen = root.querySelector('[data-pk-gf-eingrenzen]');
  const eingrenzenZahl = root.querySelector('[data-pk-gf-eingrenzen-zahl]');
  const mehrBox = root.querySelector('[data-pk-gf-mehr-box]');
  const mehrKnopf = root.querySelector('[data-pk-gf-mehr]');
  const teilenKnopf = root.querySelector('[data-pk-gf-teilen]');
  const resetKnopf = root.querySelector('[data-pk-gf-reset]');
  const karten = [...liste.querySelectorAll('.pk-gf__karte')];
  const chips = [...root.querySelectorAll('.pk-chip[data-gruppe]')];
  const proSeite = Number(root.dataset.proSeite) || 24;
  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let sichtbar = proSeite;
  let schritt = 'fuer';
  const auswahl = {};

  const trenner = document.createElement('li');
  trenner.className = 'pk-gf__trenner';
  trenner.setAttribute('role', 'presentation');
  trenner.textContent = 'Passt zu einem Teil deiner Angaben';

  const name = (gruppe, wert) => {
    const chip = chips.find((c) => c.dataset.gruppe === gruppe && c.dataset.wert === wert);
    return chip ? chip.textContent.trim() : wert;
  };

  const passt = (karte, gruppe, wert) => {
    if (gruppe === 'budget') {
      const preis = Number(karte.dataset.preis);
      const [von, bis] = BUDGET[wert] || [0, Infinity];
      return preis >= von && preis <= bis;
    }
    return karte.dataset.merkmale.includes(`|${gruppe}:${wert}|`);
  };

  // „N weitere“ zeigt die übrigen Antworten einer Frage
  const alleZeigen = (box) => {
    box.querySelectorAll('[data-pk-gf-mehr-wert]').forEach((c) => (c.hidden = false));
    const knopf = box.querySelector('[data-pk-gf-alle]');
    if (knopf) knopf.hidden = true;
  };
  root.querySelectorAll('[data-pk-gf-alle]').forEach((knopf) =>
    knopf.addEventListener('click', () => {
      const box = knopf.parentElement;
      const erster = box.querySelector('[data-pk-gf-mehr-wert]');
      alleZeigen(box);
      if (erster) erster.focus();
    })
  );

  // Budget-Knöpfe ohne Treffer ausblenden (die übrigen Gruppen filtert schon Liquid)
  chips
    .filter((c) => c.dataset.gruppe === 'budget')
    .forEach((c) => {
      if (!karten.some((k) => passt(k, 'budget', c.dataset.wert))) c.hidden = true;
    });

  // Auswahl aus der Adresse übernehmen
  const params = new URLSearchParams(window.location.search);
  GRUPPEN.forEach((gruppe) => {
    let wert = params.get(gruppe);
    if (!wert) return;
    if (gruppe === 'budget' && Number(wert) > 50) wert = 'ueber50';
    const chip = chips.find((c) => c.dataset.gruppe === gruppe && c.dataset.wert === wert);
    if (!chip || (chip.hidden && !chip.hasAttribute('data-pk-gf-mehr-wert'))) return;
    auswahl[gruppe] = wert;
    if (chip.hidden) alleZeigen(chip.parentElement);
  });
  // Mit Auswahl aus einem Link geht es beim ersten offenen Schritt weiter
  schritt = SCHRITTE.find((s) => !auswahl[s]) || 'fertig';
  if (schritt !== 'fertig' && !SCHRITTE.some((s) => auswahl[s])) schritt = 'fuer';

  const adresseSetzen = () => {
    const neu = new URLSearchParams();
    GRUPPEN.forEach((g) => auswahl[g] && neu.set(g, auswahl[g]));
    const query = neu.toString();
    window.history.replaceState(null, '', query ? `${window.location.pathname}?${query}` : window.location.pathname);
  };

  const schritteZeigen = () => {
    root.querySelectorAll('[data-pk-gf-schritt]').forEach((box) => (box.hidden = box.dataset.pkGfSchritt !== schritt));
    root.querySelectorAll('[data-pk-gf-zu]').forEach((knopf) => {
      const g = knopf.dataset.pkGfZu;
      if (g === schritt) knopf.setAttribute('aria-current', 'step');
      else knopf.removeAttribute('aria-current');
      knopf.classList.toggle('ist-gewaehlt', Boolean(auswahl[g]));
      knopf.querySelector('[data-pk-gf-wahl]').textContent = auswahl[g] ? name(g, auswahl[g]) : '';
    });
  };

  const anwenden = () => {
    if (!KINDER.includes(auswahl.fuer)) delete auswahl.alter;

    chips.forEach((c) => c.setAttribute('aria-pressed', String(auswahl[c.dataset.gruppe] === c.dataset.wert)));
    const alterBox = root.querySelector('[data-gruppe-box="alter"]');
    if (alterBox) alterBox.hidden = !KINDER.includes(auswahl.fuer);
    schritteZeigen();

    const extras = EXTRAS.filter((g) => auswahl[g]).length;
    eingrenzenZahl.textContent = extras ? String(extras) : '';

    const gewaehlt = Object.entries(auswahl);
    const n = gewaehlt.length;
    const bewertet = karten.map((k) => {
      const treffer = gewaehlt.filter(([g, w]) => passt(k, g, w));
      return { k, punkte: treffer.length, treffer };
    });
    const zahl = (k, feld) => Number(k.dataset[feld]) || 0;
    bewertet.sort(
      (a, b) =>
        b.punkte - a.punkte ||
        zahl(b.k, 'verfuegbar') - zahl(a.k, 'verfuegbar') ||
        zahl(b.k, 'auswahl') - zahl(a.k, 'auswahl') ||
        zahl(b.k, 'beliebt') - zahl(a.k, 'beliebt') ||
        zahl(a.k, 'pos') - zahl(b.k, 'pos')
    );

    const exakt = n ? bewertet.filter((b) => b.punkte === n) : bewertet;
    const teil = n ? bewertet.filter((b) => b.punkte > 0 && b.punkte < n) : [];
    let zeigen;
    let text;
    let hinweisText = '';

    if (!n) {
      zeigen = bewertet;
      text = `${karten.length} Geschenkideen aus unserem Sortiment`;
    } else if (exakt.length) {
      zeigen = exakt.concat(teil);
      text = `${exakt.length} ${exakt.length === 1 ? 'Geschenk passt' : 'Geschenke passen'} zu deiner Auswahl`;
    } else if (teil.length) {
      zeigen = teil;
      text = 'Nichts passt zu allen Angaben';
      hinweisText = 'Oben steht, was die meisten deiner Angaben erfüllt. Nimm eine Angabe weg, dann findest du mehr.';
    } else {
      zeigen = bewertet;
      text = 'Zu dieser Auswahl gibt es noch kein Produkt';
      hinweisText = 'Hier sind alle Geschenkideen. Nimm eine Angabe weg, dann wird die Auswahl größer.';
    }

    const mitTrenner = n > 0 && exakt.length > 0 && teil.length > 0;
    const fragment = document.createDocumentFragment();
    zeigen.forEach((b, i) => {
      if (mitTrenner && b === teil[0]) fragment.append(trenner);
      const passtBox = b.k.querySelector('.pk-gf__passt');
      passtBox.replaceChildren(
        ...b.treffer.map(([g, w]) => {
          const s = document.createElement('span');
          s.textContent = name(g, w);
          return s;
        })
      );
      passtBox.hidden = !b.treffer.length;
      b.k.hidden = i >= sichtbar;
      fragment.append(b.k);
    });
    const gezeigt = new Set(zeigen.map((b) => b.k));
    karten.forEach((k) => {
      if (!gezeigt.has(k)) {
        k.hidden = true;
        fragment.append(k);
      }
    });
    liste.replaceChildren(fragment);
    trenner.hidden = sichtbar <= exakt.length;

    status.textContent = text;
    hinweis.textContent = hinweisText;
    hinweis.hidden = !hinweisText;
    aktionen.hidden = !n;
    mehrBox.hidden = zeigen.length <= sichtbar;
  };

  // Nächster Schritt; nach dem letzten geht es zu den Ergebnissen (erst nach anwenden(), weil der Kopf dabei schrumpft)
  const weiter = () => {
    const i = SCHRITTE.indexOf(schritt);
    schritt = SCHRITTE[i + 1] || 'fertig';
    return schritt === 'fertig';
  };
  const zuDenErgebnissen = () => ergebnis.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });

  chips.forEach((chip) =>
    chip.addEventListener('click', () => {
      const { gruppe, wert } = chip.dataset;
      const neu = auswahl[gruppe] !== wert;
      if (neu) auswahl[gruppe] = wert;
      else delete auswahl[gruppe];
      sichtbar = proSeite;
      const fertig = neu && gruppe === schritt && weiter();
      anwenden();
      adresseSetzen();
      if (fertig) zuDenErgebnissen();
    })
  );

  root.querySelectorAll('[data-pk-gf-weiter]').forEach((knopf) =>
    knopf.addEventListener('click', () => {
      const fertig = weiter();
      anwenden();
      if (fertig) zuDenErgebnissen();
    })
  );

  root.querySelectorAll('[data-pk-gf-zu]').forEach((knopf) =>
    knopf.addEventListener('click', () => {
      schritt = knopf.dataset.pkGfZu;
      schritteZeigen();
    })
  );

  mehrKnopf.addEventListener('click', () => {
    sichtbar += proSeite;
    anwenden();
  });

  resetKnopf.addEventListener('click', () => {
    GRUPPEN.forEach((g) => delete auswahl[g]);
    sichtbar = proSeite;
    schritt = 'fuer';
    if (eingrenzen) eingrenzen.open = false;
    anwenden();
    adresseSetzen();
    panel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
  });

  teilenKnopf.addEventListener('click', async () => {
    const url = window.location.href;
    const vorher = teilenKnopf.textContent;
    try {
      await navigator.clipboard.writeText(url);
      teilenKnopf.textContent = 'Link kopiert';
    } catch (e) {
      window.prompt('Link zu deiner Auswahl:', url);
    }
    setTimeout(() => (teilenKnopf.textContent = vorher), 2000);
  });

  panel.hidden = false;
  if (eingrenzen) {
    eingrenzen.hidden = false;
    eingrenzen.open = EXTRAS.some((g) => auswahl[g]);
  }
  anwenden();
})();
